import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=65f5945e&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=65f5945e&prod&lang=scss&scoped=true"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=65f5945e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5945e",
  null
  
)

export default component.exports